export default function PHP_public() {
  return (
    <div>
      <h1>PHP_public</h1>
    </div>
  );
}
